import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import Modal from "react-modal";
import { FaRegTimesCircle } from "react-icons/fa";
import Select from "react-select";
import 'react-bootstrap-typeahead/css/Typeahead.css'; // Import CSS for Typeahead
import { useDebounce } from 'use-debounce';
import { getData, postData } from "../store/utils";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { FaUpload } from "react-icons/fa";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "50%",
        maxWidth: "50%",
    },
};

function PurchaseReceives() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const today = new Date().toISOString().split("T")[0]; // Get today's date
    const [itemListData, setItemListData] = useState([])
    const [searchText, setSearchText] = useState('');
    const [searchValue] = useDebounce(searchText, 1000);
    const [brandId, setBrandId] = useState('')
    const [errors, setErrors] = useState({});
    const [showTopMessage, setShowTopMessage] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [purchaseOrderList, setPurchaseOrderList] = useState([]);
    const [wareHouseList, setWareHouseList] = useState([]);
    const [receivedData, setReceivedData] = useState([]);
    const [prNumber, setPRnumber] = useState([]);

    const history = useHistory();

    const [formData, setFormData] = useState({
        visibleLable: false,
        vendorId: "",
        vendorName: "",
        purchaseOrderId: "",
        purchaseOrder: "",
        purchaseReceive: prNumber,
        // orderTotal: "",
        // orderTotalWithDiscount: "",
        receiveDate: today,
        notes: "",
        orderDetails: [
            {
                productId: "",
                purchaseOrderDetailId: "",
                ordered: "",
                received: 0,
                inTransit: 0,
                quantityToReceive: 0,
            }
        ],
        file: [
            {
                fileType: "",
                file: ""
            }
        ],
    });


    // Calculate Subtotal
    const subTotal = formData?.orderDetails.reduce(
        (total, row) => total + (parseFloat(row?.totalAmount) || 0),
        0
    );

    // Calculate Discount Amount
    const discountAmount = (subTotal * parseFloat(formData.discount || 0)) / 100;

    // Calculate Total after Discount & Adjustment
    const totalAfterDiscount = subTotal - discountAmount;
    const finalTotal = totalAfterDiscount + parseFloat(formData.adjustmentInRupees || 0);

    // Update formData when discount or adjustment changes
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            orderTotal: subTotal.toFixed(2),
            orderTotalWithDiscount: finalTotal.toFixed(2),
        }));
    }, [subTotal, discountAmount, finalTotal]);


    async function getVendors() {
        setIsLoadingOn(true);
        const tempData = await getData("users/distributorUser/1");
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.records) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.id,
                label: `${element.shopName} (${element.name})`,
            }));

            setVendorList(tempDistData || []);

        } else {
            console.error("Error fetching User brands.");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    async function getReceiveOrder(vendorId) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getPurchaseOrder?vendorId=${vendorId}&received=No`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200 && Array.isArray(tempData?.data?.records)) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.purchaseOrderId,
                label: element.purchaseOrder,
            }));
            setPurchaseOrderList(tempDistData);
            console.log("Receive Order List:", tempDistData);
        } else {
            setPurchaseOrderList([]); // prevent .map crash
            console.error("Error fetching Purchase Orders", tempData);
            // Swal.fire({
            //     title: "Error!",
            //     text: tempData?.data?.errors?.msg || "Something went wrong!!!",
            // });
        }
    }

    useEffect(() => {
        if (formData.purchaseOrderId && formData.vendorId) {
            getPurchaseOrderDetails();
        }
    }, [formData.purchaseOrderId, formData.vendorId]);


    async function getPurchaseOrderDetails() {
        setIsLoadingOn(true);
        // const tempData = await getData(`inventory/getPurchaseOrderDetails?purchaseOrderId=23&vendorId=17`);
        const tempData = await getData(`inventory/getPurchaseOrderDetails?purchaseOrderId=${formData.purchaseOrderId}&vendorId=${formData.vendorId}`);
        console.log("tempData=======+++", tempData);
        setIsLoadingOn(false);
        if (tempData.statusCode === 200) {
            setReceivedData(tempData.data);
        } else {
            console.error("Error fetching User brands.");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    async function getPurchaseRO() {
        setIsLoadingOn(true);
        const tempData = await getData("/inventory/getPurchaseReceiveIds");

        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data) {
            setPRnumber(tempData?.data?.nextPurchaseReceiveId)

        } else {
            console.error("Error fetching User brands.");
            // Swal.fire({
            //     title: "Error!",
            //     text: tempData?.data?.errors.msg || "Something went wrong!!!"
            // })
        }
    }

    useEffect(() => {
        if (prNumber) {
            setFormData((prev) => ({
                ...prev,
                purchaseReceive: prNumber
            }));
        }
    }, [prNumber]);


    useEffect(() => {
        getVendors();
        getPurchaseRO();
        // getWarehouse();
    }, [])

    const validateForm = () => {
        let newErrors = {};
        if (!formData.vendorName) {
            newErrors.vendorName = "Vendor Name is required.";
        }

        if (!formData.purchaseOrder) {
            newErrors.purchaseOrder = "Purchase Order is required.";
        }

        if (!formData.purchaseReceive) {
            newErrors.purchaseReceive = "Purchase Receive is required.";
        }

        if (!formData.receiveDate) {
            newErrors.receiveDate = "Receive Date is required.";
        }

        // Validate quantityToReceive for each product
        formData.orderDetails.forEach((item, index) => {
            const received = Number(item?.received || 0);
            const ordered = Number(item?.quantity || 0);
            const toReceive = Number(item?.quantityToReceive || 0);

            const maxAllowed = (ordered - received);

            if (toReceive > maxAllowed) {
                newErrors[`quantityToReceive_${index}`] = `Only ${maxAllowed} remaining to receive.`;
            }

            if (toReceive < 0) {
                newErrors[`quantityToReceive_${index}`] = `Quantity to receive cannot be negative.`;
            }
        });



        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleAddVendorNameChange = (selectedOption) => {
        if (selectedOption) {
            const selectedVendorName = selectedOption.label;
            const selectedVendorId = selectedOption.value;

            setFormData((prevFormData) => ({
                ...prevFormData,
                vendorName: selectedVendorName,
                vendorId: selectedVendorId,
            }));

            // ✅ Call API with the selected vendor name directly
            getReceiveOrder(selectedVendorId);
        }
    };

    const handlePurchaseOrderChange = (selectedOption) => {
        console.log("selectedOption", selectedOption);

        if (selectedOption) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                purchaseOrder: selectedOption.label,
                purchaseOrderId: selectedOption.value,
            }));
        }
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }

    // const handleChangeQuantityToReceive = (e, index, section) => {
    //     const { name, value } = e.target;

    //     setFormData((prevFormData) => {
    //         if (Array.isArray(prevFormData[section])) {
    //             // Handling nested array state (like orderDetails)
    //             const updatedSection = [...prevFormData[section]];
    //             if (updatedSection[index]) {
    //                 updatedSection[index] = {
    //                     ...updatedSection[index],
    //                     [name]: value,
    //                 };
    //             }
    //             return {
    //                 ...prevFormData,
    //                 [section]: updatedSection,
    //             };
    //         } else {
    //             // Handling top-level state (like purchaseReceive, receiveDate)
    //             return {
    //                 ...prevFormData,
    //                 [section]: {
    //                     ...prevFormData[section],
    //                     [name]: value,
    //                 },
    //             };
    //         }
    //     });
    // };

    const handleChangeQuantityToReceive = (e, index, section) => {
        const { name, value } = e.target;

        // Parse value to number, allow 0
        const numericValue = value === '' ? '' : Number(value);

        setFormData((prevFormData) => {
            const updatedSection = [...prevFormData[section]];

            if (!updatedSection[index]) return prevFormData;

            updatedSection[index] = {
                ...updatedSection[index],
                [name]: numericValue,
            };

            return {
                ...prevFormData,
                [section]: updatedSection,
            };
        });
    };





    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const maxFiles = 3;
        const maxSize = 5 * 1024 * 1024; // 5MB

        let newErrors = {};

        if (files.length > maxFiles) {
            newErrors.images = `Maximum ${maxFiles} images allowed.`;
        }

        const invalidSize = files.find((file) => file.size > maxSize);
        if (invalidSize) {
            newErrors.images = "Each image must be less than 5 MB.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors((prev) => ({ ...prev, ...newErrors }));
            setFormData((prev) => ({ ...prev, images: [] }));
        } else {
            // Convert each file to base64
            const base64Files = await Promise.all(
                files.map((file) => convertToBase64(file))
            );

            // Save in formData (you can store fileType as well if needed)
            const fileData = base64Files.map((base64, idx) => ({
                fileType: "image",
                file: base64,
            }));

            setFormData((prev) => ({ ...prev, file: fileData }));
            setErrors((prev) => ({ ...prev, images: null }));
        }
    };


    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1]; // 👈 remove data:image/... part
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setIsLoadingOn(true);
        // const cleanedOrderDetails = receivedData.map((item) => ({
        //     productId: item.productId,
        //     purchaseOrderDetailId: item.purchaseOrderDetailId,
        //     ordered: item.quantity || 0,
        //     received: item.received || 0,
        //     inTransit: item.inTransit || 0,
        //     quantityToReceive: item.quantityToReceive || 0,
        // }));

        const payload = {
            ...formData, // includes updated orderDetails
        };


        if (validateForm()) {

            setIsLoadingOn(true);
            const res = await postData(`inventory/createPurchaseReceive`, payload);
            setIsLoadingOn(false);
            if (res.statusCode == 200) {
                // history.push('/ProgramList');
                setShowTopMessage(true);
                setTimeout(() => {
                    setShowTopMessage(false);
                }, 3000);
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Data inserted successfully!",
                });
                setTimeout(() => {
                    history.push('/purchasereceivesList');
                }, 3000);

            }
        }
        setIsLoadingOn(false);
    }

    const handleSearchChange = async (selected) => {
        setSearchText(selected)
    };


    async function getProductList(typeValue) {
        // const brandId = 1; // Replace with the actual brand ID you want to use
        setIsLoadingOn(true);
        try {
            const tempData = await getData(`inventory/searchForItemProduct?pageSize=100&page=1&brandId=${brandId}&search=${typeValue}`);

            if (tempData?.statusCode === 200 && tempData?.data && tempData?.data?.records) {

                const tempDistData = tempData?.data?.records?.map((element) => {
                    return element
                })
                setItemListData(tempDistData);
            } else {
                console.error("Unexpected response format:", tempData);
                setItemListData([]); // Set to an empty array if response is not as expected
            }
        } catch (error) {
            console.error("Error fetching item list:", error);
            setItemListData([]); // Handle error case
        } finally {
            setIsLoadingOn(false); // Ensure loading is turned off
        }
    }


    useEffect(() => {
        if (searchValue) {
            getProductList(searchValue);
        }
        // if (orderId) {
        //   getOrderquotation();
        // }
    }, [searchValue]);

    // useEffect(() => {
    //     if (receivedData && receivedData.length > 0) {
    //         const updatedOrderDetails = receivedData.map((item) => ({
    //             productId: item.productId || "",
    //             purchaseOrderDetailId: item.purchaseOrderDetailId || "",
    //             ordered: item.quantity || 0,
    //             received: item.received || 0,
    //             inTransit: item.inTransit || 0,
    //             quantityToReceive: (item.quantity || 0) - (item.received || 0),
    //         }));

    //         setFormData((prev) => ({
    //             ...prev,
    //             orderDetails: updatedOrderDetails,
    //         }));
    //     }
    // }, [receivedData]);

    useEffect(() => {
        if (receivedData) {
            setFormData((prev) => ({
                ...prev,
                orderDetails: receivedData,
            }));
        }
    }, [receivedData]);


    return (
        <div className="purchaseOrderSec">
            {isLoadingOn ? <Loader /> : ""}
            <div className="mainhd">
                <div className="d-flex justify-content-between align-items-center mainhdbrd">
                    <h4> New Purchase Receive</h4>
                </div>
                <div className="formsec purchaseform">
                    <form onSubmit={handleSubmit}>
                        <div className="topformsec">
                            <div className=" vendorsec">
                                <div className="row form-group">
                                    <div className="col-md-2">
                                        <label htmlFor="vendorName">Vendor Name</label>
                                    </div>
                                    <div className="col-md-4 dropdown">
                                        <Select
                                            placeholder="Select"
                                            name="vendorName"
                                            options={vendorList}
                                            onChange={(selectedOption) => handleAddVendorNameChange(selectedOption)}
                                        />
                                        {errors.vendorName && <small className="text-danger">{errors.vendorName}</small>}
                                    </div>
                                </div>


                                <div className="row form-group mt-4">
                                    <div className="col-md-2">
                                        <label htmlFor="productName"><span className="required">Purchase Order#*</span></label>
                                    </div>
                                    <div className="col-md-4 dropdown">
                                        <Select
                                            placeholder="Select"
                                            name="purchaseOrder"
                                            options={purchaseOrderList}
                                            onChange={(selectedOption) => handlePurchaseOrderChange(selectedOption)}
                                        />
                                        {errors.purchaseOrder && <small className="text-danger">{errors.purchaseOrder}</small>}
                                    </div>
                                </div>
                            </div>



                        </div>
                        <div className="formoverlay maskform">
                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label htmlFor="productName"><span className="required">Purchase Receive#*</span></label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        onChange={handleChange}
                                        name="purchaseReceive"
                                        value={formData.purchaseReceive}
                                    />
                                    {errors.purchaseReceive && <small className="text-danger">{errors.purchaseReceive}</small>}
                                </div>
                            </div>

                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label htmlFor="productName"><span className="required">Received Date*</span></label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="date"
                                        className="form-control"
                                        onChange={handleChange}
                                        onFocus={(e) => e.target.showPicker && e.target.showPicker()} // For Chrome-based browsers
                                        // defaultValue={today}
                                        name="receiveDate"
                                        value={formData.receiveDate}
                                    />
                                    {errors.receiveDate && <small className="text-danger">{errors.receiveDate}</small>}
                                </div>
                            </div>
                            <div className="purchaseTableSec customrowChangeOrderDetilas mt-5">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Items & Description</th>
                                            <th>Ordered</th>
                                            <th>Received</th>
                                            <th>In Transit</th>
                                            <th>Quantity to Receive</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.orderDetails?.map((item, index) => (

                                            <tr>
                                                <td>{item?.productName}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item?.received ? item?.received : "0"}</td>
                                                <td>{item.inTransit ? item.inTransit : "0"}</td>
                                                <td>
                                                    {/* <input
                                                        style={{ border: "none", outline: "none" }}
                                                        name="quantityToReceive"
                                                        value={formData.orderDetails[index].quantityToReceive}
                                                        onChange={(e) => handleChangeQuantityToReceive(e, index, 'orderDetails')}
                                                    /> */}
                                                    <input
                                                        type="number"
                                                        style={{ border: "none", outline: "none" }}
                                                        name="quantityToReceive"
                                                        // value={item.quantityToReceive || ''}
                                                        value={item.quantityToReceive === 0 ? 0 : item.quantityToReceive || ''}
                                                        onChange={(e) => handleChangeQuantityToReceive(e, index, 'orderDetails')}
                                                    />
                                                    {errors[`quantityToReceive_${index}`] && (
                                                        <div style={{ color: "#dc3545", fontSize: "12px" }}>
                                                            {errors[`quantityToReceive_${index}`]}
                                                        </div>
                                                    )}
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {errors.orderDetails && (
                                    <div className="text-danger mb-2">{errors.orderDetails}</div>
                                )}

                            </div>
                            <div className="mt-5">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="notesSec">
                                            <h6>Notes (For Internal Use)</h6>
                                            <textarea
                                                rows={3}
                                                onChange={handleChange}
                                                placeholder="Enter the terms and conditions of your business to be displayed in your transaction"
                                                name="notes"
                                                value={formData.notes}
                                            ></textarea>

                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-sm-8 brdrt">
                                        <h6>Attach File(s) to Purchase Receive</h6>
                                        <div className="fileuploadcontainer">
                                            <div className="fileUploadsec">
                                                <FaUpload /> <span>Upload File</span>
                                                <input
                                                    type="file"
                                                    className="fileupload"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    name="file"
                                                // value={formData.file}
                                                />
                                            </div>
                                        </div>
                                        <p className="note">You can upload a maximum of 5 files, 10MB each</p>
                                    </div>
                                </div>
                            </div>
                            <div className="btnfooter">
                                <button className="btn btn-primary mt-4 mb-4" type="submit">Save & Send</button>
                                <Link to={'/purchasereceivesList'}><button className="btn btn-secondary ms-3">Cancel</button></Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default PurchaseReceives;
